var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.video.video_service !== 'oblyk_video')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.video.embedded_code)}}):_c('div',[_c('oblyk-video',{attrs:{"video":_vm.video}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }